import styled from 'styled-components/macro';

export const ScHaveAccountButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  flex-wrap: wrap;

  span {
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.grayColor1};
  }

  .reg-link {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 700;
    text-transform: capitalize;
    svg {
      transition: 0.3s;
      padding-left: 0px;
      padding-top: 1px;

      path {
        fill: ${({ theme }) => theme.grayColor1};
      }
    }
  }

  @media (hover: hover) {
    &:hover {
      .reg-link {
        color: ${({ theme }) => theme.whiteColor};

        svg {
          padding-left: 4px;

          path {
            fill: ${({ theme }) => theme.whiteColor};
          }
        }
      }
    }
  }
`;
